<template>
  <div
    class="tab-root"
    :class="{ 'bg-change': tabBgChange }"
    @mouseover="hoverMiss">
      <div
        class="tab">
          <div
            class="right">
              <div class="logo" @click.stop="goIndex" >
                <img src="~@/assets/images/logo_chinese.svg" class="logo-img">
              </div>
          </div>

          <div class="other">
            <div class="menu">
              <div
                class="menu-item"
                :class="{
                  'hover-item': hoverNum === index
                }"
                v-for="(menu, index) in $t('messages.tab')"
                :key="index"
                :ref="`menu${index}`"
                @click.stop="goPage(menu, 0)"
                @mouseover.stop="hoverMenu(index, menu)"
                @mouseleave.stop="hoverMiss">
                  <span
                    :class="{'isunselect': !tabItem.cn || (tabItem.cn && menu.title !== tabItem.cn && menu.title !== tabItem.en)}">
                      {{ menu.title }}
                  </span>

                  <transition name="dialog-show">
                    <div
                      class="second-dialog"
                      :class="{ 'second-dialog-en': getLang()!== 'zh-CN' }"
                      v-show="hoverNum === index"
                      @mouseleave.stop="hoverMiss">

                        <div
                          class="second-item"
                          v-for="(second, index) in hoverItem.children"
                          @click.stop="goPage(hoverItem, index)"
                          :key="index">
                            <span
                              :class="{ unselect: !tabItem.cn || (tabItem.cn && secondPage.cn !== second && secondPage.en !== second)}">{{ second }}
                            </span>
                        </div>

                    </div>
                  </transition>
              </div>
            </div>

            <div class="lang">

              <div
                class="en lang-text"
                :class="{'choose-lang': $i18n.locale !== 'zh-CN'}"
                @click.stop="changeLang('en-US')">
                EN
              </div>
              &nbsp;&nbsp;<div class="interval"></div>&nbsp;&nbsp;

              <div
                class="cn lang-text"
                :class="{'choose-lang': $i18n.locale === 'zh-CN'}"
                @click.stop="changeLang('zh-CN')">
                中
              </div>

            </div>

            <a href="http://bs.ai.sjtu.edu.cn/" target="_blank" class="bs-btn">预约</a>

            <img
              class="icon-search"
              src="~@/assets/images/search.svg"
              @click.stop="searchNews" />

            <img
              @click.stop="setMapShow"
              class="icon-menu"
              src="~@/assets/images/menu.svg">
          </div>


      </div>
  </div>

</template>

<script>
/* eslint-disable max-len */
import { setLang, getLang } from '@/utils'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'tab-commonality',

  data() {
    return {
      hoverItem: [],
      top: 0,
      left: 0,
      hoverNum: -1,
    }
  },

  watch: {
    tabItem() {
    },

    '$i18n.locale': {
      deep: true,
      handler(val) {
        setLang(val)
      }
    },
  },

  computed: {
    ...mapState('home', [
      'tabBgChange',
      'tabItem',
      'isSearch',
      'secondPage'
    ])
  },

  mounted() {
    setLang(this.$i18n.locale)
  },

  methods: {
    ...mapMutations('home', [
      'SETUP_IS_SHEARCH',
      'SETUP_SCROLL_TOP',
      'SETUP_TAB',
      'SETUP_MAP_SHOW',
      'SETUP_SECOND_PAGE'
    ]),

    getLang,

    setMapShow() {
      this.SETUP_MAP_SHOW({
        type: true
      })
    },

    goIndex() {
      this.SETUP_IS_SHEARCH({
        type: false,
      })
      this.$router.push('/')
    },

    goPage(item, index) {
      if (this.$i18n.locale === 'zh-CN') {
        if (item.title === '研究院概况') {
          this.goChildrenPageCN('/about', item.children[index])
          this.SETUP_TAB({
            tab: {
              en: 'About',
              cn: '研究院概况'
            }
          })
        } else if (item.title === '研究中心') {
          this.$router.push('/center')
          this.SETUP_TAB({
            tab: {
              en: 'Center',
              cn: '研究中心'
            }
          })
        } else if (item.title === '师资队伍') {
          // TODO
          // this.goChildrenPageCN('/faculty', item.children[index])
          // this.SETUP_TAB({
          //   tab: {
          //     en: 'Faculty',
          //     cn: '师资队伍'
          //   }
          // })
        } else if (item.title === '新闻通告') {
          this.goChildrenPageCN('/info', item.children[index])
          this.SETUP_TAB({
            tab: {
              en: 'News',
              cn: '新闻通告'
            }
          })
        } else if (item.title === '人才培养') {
          this.goChildrenPageCN('/cultivate', item.children[index])
          this.SETUP_TAB({
            tab: {
              en: 'Cultivate',
              cn: '人才培养'
            }
          })
        } else if (item.title === '首页') {
          this.$router.push('/')
          this.SETUP_TAB({
            tab: {
              en: 'Home',
              cn: '首页'
            }
          })
        } else {
          this.goChildrenPageCN('/research', item.children[index])
          this.SETUP_TAB({
            tab: {
              en: 'Research',
              cn: '科学研究'
            }
          })
        }
        return
      }

      if (item.title === 'About') {
        this.goChildrenPageEN('/about', item.children[index])
        this.SETUP_TAB({
          tab: {
            en: 'About',
            cn: '研究院概况'
          }
        })
      } else if (item.title === 'Faculty') {
        // TODO
        // this.goChildrenPageEN('/faculty', item.children[index])
        // this.SETUP_TAB({
        //   tab: {
        //     en: 'Faculty',
        //     cn: '师资队伍'
        //   }
        // })
      } else if (item.title === 'News & Events') {
        this.goChildrenPageEN('/info', item.children[index])
        this.SETUP_TAB({
          tab: {
            en: 'News',
            cn: '新闻通告'
          }
        })
      } else if (item.title === 'Research Center') {
        this.$router.push('/center')
        this.SETUP_TAB({
          tab: {
            en: 'Center',
            cn: '研究中心'
          }
        })
      } else if (item.title === 'Students') {
        this.goChildrenPageEN('/cultivate', item.children[index])
        this.SETUP_TAB({
          tab: {
            en: 'Students',
            cn: '人才培养'
          }
        })
      } else if (item.title === 'Home') {
        this.$router.push('/')
        this.hoverNum = -1
        this.SETUP_TAB({
          tab: {
            en: 'Home',
            cn: '首页'
          }
        })
      } else {
        this.goChildrenPageEN('/research', item.children[index])
        this.SETUP_TAB({
          tab: {
            en: 'Research',
            cn: '科学研究'
          }
        })
      }
    },

    goChildrenPageCN(path, secondPage) {
      switch (secondPage) {
        case '研究院简介': {
          this.$router.push(`${path}/profile`)
          break;
        }

        case '研究院领导': {
          this.$router.push(`${path}/leaders`)
          break;
        }

        case '历任领导': {
          this.$router.push(`${path}/previous`)
          break;
        }

        case '行政办公': {
          this.$router.push(`${path}/office`)
          break;
        }

        case '教师名录': {
          this.$router.push(`${path}/teachers`)
          break;
        }

        case '杰出人才': {
          this.$router.push(`${path}/talents`)
          break;
        }

        case '博士后': {
          this.$router.push(`${path}/postdoc`)
          break;
        }

        case '新闻信息': {
          this.$router.push(`${path}/news`)
          break;
        }

        case '通知公告': {
          this.$router.push(`${path}/announcements`)
          break;
        }

        case '学术动态': {
          this.$router.push(`${path}/academic`)
          break;
        }

        case '招聘信息': {
          this.$router.push(`${path}/jobs`)
          break;
        }

        case '吴文俊人工智能荣誉博士班': {
          this.$router.push(`${path}/postgraduate`)
          break;
        }

        // case '研究方向': {
        //   this.$router.push(`${path}/directions`)
        //   break;
        // }

        case '学科基地': {
          this.$router.push(`${path}/bases`)
          break;
        }

        case '科研成果': {
          this.$router.push(`${path}/results`)
          break;
        }

        default:
          this.$router.push('/')
          break;
      }
      this.hoverNum = -1
    },

    goChildrenPageEN(path, secondPage) {
      switch (secondPage) {
        case 'Overview': {
          this.$router.push(`${path}/profile`)
          break;
        }

        case 'Leadership': {
          this.$router.push(`${path}/leaders`)
          break;
        }

        case 'Previous leaders': {
          this.$router.push(`${path}/previous`)
          break;
        }

        case 'Administrative Staff': {
          this.$router.push(`${path}/office`)
          break;
        }

        case 'Teacher directory': {
          this.$router.push(`${path}/teachers`)
          break;
        }

        case 'Outstanding talent': {
          this.$router.push(`${path}/talents`)
          break;
        }

        case 'Postdoctoral': {
          this.$router.push(`${path}/postdoc`)
          break;
        }

        case 'News': {
          this.$router.push(`${path}/news`)
          break;
        }

        case 'Events': {
          this.$router.push(`${path}/announcements`)
          break;
        }

        case 'Academic Activities': {
          this.$router.push(`${path}/academic`)
          break;
        }

        case 'Recruitment': {
          this.$router.push(`${path}/jobs`)
          break;
        }

        case 'Graduate': {
          this.$router.push(`${path}/postgraduate`)
          break;
        }

        case 'Centers & Labs': {
          this.$router.push(`${path}/bases`)
          break;
        }

        case 'Achievements': {
          this.$router.push(`${path}/results`)
          break;
        }

        default:
          this.$router.push('/')
          break;
      }
      this.hoverNum = -1
    },

    changeLang(lang) {
      setLang(lang)
      this.$i18n.locale = lang
    },

    hoverMenu(index, item) {
      if (index === 3 || index === 0) {
        return
      }
      const menu = this.$refs[`menu${index}`]
      this.hoverNum = index
      this.hoverItem = item
      this.left = menu[0].offsetLeft
      this.top = menu[0].offsetTop + 72
    },

    hoverMiss() {
      this.hoverItem = []
      this.hoverNum = -1
    },

    searchNews() {
      let scrollTop = 0
      const userAgent = navigator.userAgent
      if (userAgent.indexOf('Chrome') === -1 && userAgent.indexOf('Safari') > -1) {
        scrollTop = window.pageYOffset
      } else {
        scrollTop = document.documentElement.scrollTop
      }


      if (!this.isSearch && location.pathname !== '/search') {
        this.SETUP_IS_SHEARCH({
          type: true,
        })

        this.SETUP_SCROLL_TOP({
          top: scrollTop,
        })
      } else {
        this.SETUP_IS_SHEARCH({
          type: false,
        })
        this.$router.back(-1)
      }
    },
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/colors.less';

.fade-in(@className, @keyframeName) {
  .@{className}-enter-active {
    animation: @keyframeName .3s ease-in-out;
  }
}

.fade-in(dialog-show, tbSlideUpIn);

@keyframes tbSlideUpIn {
  0% {
    opacity: 0;
    transform-origin: 0% 0%;
    transform: scaleY(.8);
  }
  100% {
    opacity: 1;
    transform-origin: 0% 0%;
    transform: scaleY(1);
  }
}

// @media screen and (max-width: 1440px) {
.tab-root {
  height: 72px;
  background: transparent;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 480;
  width: 100%;
  // min-width: 1080px;
  // min-width: 1220px;
}

.tab {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-shrink: 0;
  width: 100%;
  padding: 0 10px;
}

@media screen and (min-width: 1080px) {
  .tab {
    padding: 0 50px;
  }
}

// @media screen and (max-width: 1220px) {
//   .tab {
//     padding: 0 45px 0 40px;
//   }
// }

  .bg-change {
    // background-image: linear-gradient(-232deg, #a2327e 0%, #7548F6 100%);
    // background:linear-gradient(55deg, #1c203d 0%, #362c68 90%);
    background: @pageBg;
  }

  .logo {
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;

    .logo-img {
      height: 40px;
      width: 235px;
      margin-right: 10px;
    }

    @media screen and (min-width: 1080px) {
      .logo-img {
        width: 335px;
      }
    }
  }
// }

.right {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}


.menu {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  .menu-item {
    font-size: 14px;
    color: white;
    padding: 0 14px;
    cursor: pointer;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    letter-spacing: 0;
    line-height: 14px;
    font-weight: 500;
    text-shadow: 0 2px 6px rgba(0,0,0,0.20);
    position: relative;
    white-space: nowrap;
  }

  @media screen and (max-width: 1220px) {
    .menu-item {
      padding: 0 24px 0 0;
    }

    .second-dialog{
      left: -24px;
    }
  }

  @media screen and (min-width: 1080px) {
    .menu-item {
      padding: 0 24px 0 0;
    }
  }

  .isunselect {
    opacity: 0.5;
  }
}

.other {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  .lang {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: white;
    cursor: default;
    margin-left: 15px;

    .lang-text {
      opacity: 0.4;
      color: white;
      font-size: 14px;
      cursor: pointer;
      font-weight: 500;
      line-height: 14px;
    }

    .interval {
      height: 16px;
      width: 1px;
      background: white;
    }

    .choose-lang {
      opacity: 1;
    }

  }

  .login {
    font-size: 14px;
    color: #FFFFFF;
    margin-left: 44px;
    cursor: pointer;
  }

  .bs-btn {
    font-size: 14px;
    margin-left: 15px;
    color: white;
    line-height: 1;
    opacity: 0.4;
  }

  .bs-btn:hover {
    opacity: 1;
  }

  .icon-search {
    margin-left: 15px;
    height: 20px;
    width: 20px;
    color: white;
    line-height: 1;
    cursor: pointer;
  }

  .icon-menu {
    margin: 0 -1px 0 30px;
    height: 20px;
    width: 20px;
    color: white;
    line-height: 1;
    cursor: pointer;
  }
}

.second-dialog {
  position: absolute;
  background: #192030;
  display: flex;
  flex-direction: column;
  top: 56px;
  left: 0;
  border-radius: 2px;
  padding: 8px 0;

  .second-item {
    padding: 0 24px;
    min-width: 104px;
    height: 46px;
    color: white;
    font-size: 14px;
    line-height: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    white-space: nowrap;
    opacity: 0.9;

    &:hover{
      background: linear-gradient(to right, #ac2489 0%, #7548f6 100%);
      .unselect{
        opacity: 0.9;
      }
    }
    .unselect {
      opacity: 0.5;
    }
  }
}


</style>



// WEBPACK FOOTER //
// tab-commonality.vue?03196596